import { render, staticRenderFns } from "./DeliveryRouteConfigRules.vue?vue&type=template&id=096cfedb"
import script from "./DeliveryRouteConfigRules.vue?vue&type=script&lang=js"
export * from "./DeliveryRouteConfigRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports